// src/components/games/edit/GameEditRating.js
import React from 'react';

// 등급별 정보, 아이콘 경로, 설명
const RATING_INFOS = {
  '전체 이용가': {
    title: '전체 이용가',
    desc: '누구나 제한 없이 이용 가능한 게임입니다.',
    icon: { src: '/images/rating/rating-all.png', label: '전체이용가' }
  },
  '12세 이용가': {
    title: '12세 이용가',
    desc: '이 게임은 만 12세 이상 이용자만 구매 및 이용이 가능합니다.',
    icon: { src: '/images/rating/rating-12.png', label: '12세이용가' }
  },
  '15세 이용가': {
    title: '15세 이용가',
    desc: '본 게임은 만 15세 이상 이용자만 구매 및 이용이 가능합니다.',
    icon: { src: '/images/rating/rating-15.png', label: '15세이용가' }
  },
  '청소년 이용불가': {
    title: '청소년 이용불가',
    desc: '본 게임은 청소년은 이용할 수 없습니다.',
    icon: { src: '/images/rating/rating-19.png', label: '청소년 이용불가' }
  },
};

function GameEditRating({ rating }) {
  const info = RATING_INFOS[rating];

  // 선택 안 됐을 때
  if (!rating) {
    return (
      <div className="bg-neutral-800 p-4 rounded text-white">
        <h4 className="text-md font-semibold mb-2">이용 등급</h4>
        <p className="text-gray-400">이용 등급이 선택되지 않았습니다.</p>
      </div>
    );
  }

  // 등록된 등급 정보가 없으면 null
  if (!info) return null;

  return (
    <div className="bg-neutral-800 p-4 rounded text-white">
      <h4 className="text-md font-semibold mb-4">이용 등급</h4>
      <div className="flex items-center gap-2">
        {/* 아이콘 */}
        <div className="flex-shrink-0">
          <img
            src={info.icon.src}
            alt={info.icon.label}
            className="w-20 h-20 object-contain rounded"
          />
        </div>
        {/* 등급명/설명 */}
        <div>
          <div className="text-base font-bold mb-1">{info.title}</div>
          <div className="text-gray-300 text-sm">{info.desc}</div>
        </div>
      </div>
    </div>
  );
}

export default GameEditRating;
